export enum enFormaBusca {
    Individual = 1,
    GrupoEmpresas = 2
}